<template>
    <div class="modal fade" id="modalAddUserChat" tabindex="-1" role="dialog" aria-labelledby="modalAddUserChat" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">

                  <h5 class="modal-title" id="confirmationModalLabel">{{$t('string.msg.chat.modal.add.user.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                          <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.list.user.label.by.type')}}
                            </label>
                            <select v-model="userType" class="form-control">
                                <option :value="null" selected>{{$t('string.msg.select.user.type.placeholder')}}</option>
                                <option value="USER-CUSTOMER">{{$t('string.msg.list.user.type.trucker')}}</option>
                                <option value="USER-COMPANY" selected>{{$t('string.msg.list.user.type.company')}}</option>
                            </select>
                        </div>

                        <div class="form-group col-md-6" v-if="userType != null && userType == 'USER-CUSTOMER'">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.list.user.label.search')}}
                            </label>
                            <input type="text" v-model="filters.name" class="form-control">
                        </div>
                        <div class="form-group col-md-6" v-else-if="userType == 'USER-COMPANY'">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.companies.search.label.name.company')}}
                            </label>
                            <input type="text" v-model="filters.name" class="form-control">
                        </div>
                    </div>

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                    </div>
                </form>

                    
                <div class="table-responsive">
                    <div id="table" style="height:450px;overflow-y:scroll">
                        <table class="table table-centered table-hover mb-0" id="datatable">
                            <thead >
                                <tr>
                                    <th class="border-top-0">{{$t('string.msg.table.list.user.label.name')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.table.list.user.label.email')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.table.list.user.label.type')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.table.list.user.label.company')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.table.list.user.label.status')}}</th>
                                </tr>
                            </thead>
                            <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                                <tr  @click="selectItem(item)">
                                    <td>
                                        <span>
                                            {{toUpperCase(item.firstName) + ' ' + toUpperCase(item.lastName) }}
                                        </span>
                                    </td>
                                    <td>
                                    <span>
                                            {{(item.email)}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.type == 'USER-COMPANY'">
                                            {{$t('string.msg.user.type.company')}}
                                        </span>
                                        <span v-else-if="item.type == 'USER-CUSTOMER'">
                                            {{$t('string.msg.user.type.customer')}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.companyUser && item.companyUser.company">
                                            {{ (item.companyUser.company.fantasyName)}}
                                        </span>
                                        <span v-else-if="item.customerUser && item.customerUser.company">
                                            {{ (item.customerUser.company.fantasyName)}}
                                        </span>
                                        <span v-else style="color:red">
                                            {{'X'}}
                                        </span>
                                    </td>
                                    <td>
                                    <span v-if="item.status">
                                            {{toUpperCase($t(item.status))}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div v-if="errors.length" class="alert alert-danger">
                    <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                    <ul>
                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>


                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{$t('string.msg.term.btn.exit')}}</button>
                </div>
            </div>
        </div>
         <Spinner />
         <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Spinner from '../../../../components/layout/Spinner';
import Toast from '../../../../components/layout/Toast';
import Controller from './CrtModalAddUser';
import JwPagination from 'jw-vue-pagination';
import Vue from 'vue'
Vue.component('jw-pagination', JwPagination);

    export default {
        components: {
        },
        props: ["order"],
        watch:{
            'order'(){
                this.order = this.order;
            },
        },
        data() {
            return {
                data:{
                  _id: null,
                  company: null
                },
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
                items: [],
                userType: null,
                PageNumbers:1,
                pageOfItems: [],
                filters: {
                    status:"ACTIVE",
                    name: "",
                    isHideDetailsCompany: false,
                    isHideDetailsManufecturerFamily: true,
                    isHideDetailsCertifies: true,
                    isHideDetailsServiceFamilies: true,
                    skip: 0,
                    limi: 999999
                }
            }
        },
        methods: Controller.methods,
        created() {
        },
        mounted(){
            Controller.init(this);
        }
     
}
</script>

